<form [formGroup]="textForm" autocomplete="off" class="form-container">
  <div
    (click)="input.focus()"
    [ngClass]="{
      'invalid-config-name': errorMsg || (!isElementFocused && ((configForm.text.value?.length || submitted)
      && ((configForm.text.invalid && configForm.text.dirty && !validators?.includes('name')) || (configForm.text.invalid&& !validators?.includes('name'))) || backendError)),
      'focused-input-default': isElementFocused,
      'disabled-input': disabled
    }"
    class="text-input-container global-transition"
    [ngStyle]="{'border': (customBorder) ? customBorder : ''}">
    <label class="text-label" for="text">
      <span *ngIf="showLabel"> {{ doNotTranslateLabel ? inputName : (fieldInfo?.translations ? fieldName : ('view_translations.' + inputName | t)) }} </span>

      <!-- <input
        #input
        (blur)="onBlurInput()"
        (change)="getValue()"
        (input)="removeBackendErrors()"
        (focus)="isElementFocused = true"
        [appAutofocus]="showAutofocus"
        [id]="fieldInfo?.system_name"
        [ngClass]="{
          'invalid-config-name': errorMsg || (!isElementFocused && ((configForm.text.value?.length || submitted)
          && ((configForm.text.invalid && configForm.text.dirty && !validators?.includes('name')) || (configForm.text.invalid&& !validators?.includes('name'))) || backendError)),
          'optional-action-text-max-width' : (optionalActionText?.length ?? 0) > 0,
          'number-wrapper' : inputType === 'number'
        }"
        id="text"
        class="text-input global-transition"
        formControlName="text"
        name="text"
        placeholder="{{ doNotTranslatePlaceholder ? placeholder : placeholderToTranslate | translate }}"
        [type]="inputType"
        [autocomplete]="autocomplete" /> -->

      <div class="input-wrapper">
        <span *ngIf="prefixText" class="prefix-text">{{prefixText}}</span>
        <input
          #input
          (blur)="onBlurInput()"
          (change)="getValue()"
          (input)="removeBackendErrors()"
          (focus)="isElementFocused = true"
          [appAutofocus]="showAutofocus"
          [id]="fieldInfo?.system_name"
          [ngClass]="{
              'invalid-config-name': errorMsg || (!isElementFocused && ((configForm.text.value?.length || submitted)
              && ((configForm.text.invalid && configForm.text.dirty && !validators?.includes('name')) || (configForm.text.invalid&& !validators?.includes('name'))) || backendError)),
              'optional-action-text-max-width' : (optionalActionText?.length ?? 0) > 0,
              'number-wrapper' : inputType === 'number',
              'has-prefix': prefixText
            }"
          id="text"
          class="text-input global-transition"
          formControlName="text"
          name="text"
          placeholder="{{ doNotTranslatePlaceholder ? placeholder : placeholderToTranslate | translate }}"
          [type]="inputType"
          [autocomplete]="autocomplete" />
      </div>

      <span
        *ngIf="(optionalActionText?.length ?? 0) > 0"
        (click)="optionalActionHandler()"
        class="optional-action-text"
        [ngClass]="{'optional-action-text-input-error': errorMsg
        || (!isElementFocused && ((configForm.text.value?.length || submitted)
        && ((configForm.text.invalid && configForm.text.dirty && !validators?.includes('name')) || (configForm.text.invalid&& !validators?.includes('name'))) || backendError)) }">
        {{ 'view_translations.' + optionalActionText | translate }}</span
      >
      <ng-container *ngIf="fieldInfo?.translations">
        <ng-container *ngFor="let name of fieldInfo?.translations">
          <div *ngIf="name.lang === panelLanguage && name.help" class="inner-container-right">
            <div [ngbTooltip]="name.help" class="tooltip-button tool-tip" container="body" placement="top-right" tooltipClass="my-configurations-tooltip">
              <nb-icon icon="info" pack="icomoon"></nb-icon>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="tooltipText">
        <div class="inner-container-right">
          <div [ngbTooltip]="tooltipText" class="tooltip-button tool-tip" container="body" placement="top-right" tooltipClass="my-configurations-tooltip">
            <nb-icon icon="info" pack="icomoon"></nb-icon>
          </div>
        </div>
      </ng-container>
    </label>
    <nb-icon
      *ngIf="errorMsg || (!isElementFocused && (configForm.text.value?.length || submitted) && ((configForm.text.invalid && configForm.text.dirty && !validators?.includes('name')) || (configForm.text.invalid&& !validators?.includes('name')) || backendError ))"
      class="error-icon"
      icon="cross-circle"
      pack="icomoon">
    </nb-icon>
  </div>
</form>
<div
  *ngIf="!isElementFocused && (configForm.text.value?.length || submitted) && ((configForm.text.invalid && configForm.text.dirty) || (configForm.text.invalid))"
  class="error-text"
  id="errorTextContainer">
  <small *ngIf="configForm.text.errors?.required" class="form-text text-danger"> {{ 'view_translations.this_field_is_required' | translate }} </small>
  <small *ngIf="configForm.text.errors?.email" class="form-text text-danger"> {{ 'view_translations.invalid_email' | translate }} </small>
  <small *ngIf="configForm.text.errors?.pattern && validators?.includes('password')" class="form-text text-danger">
    {{ 'view_translations.password_validation_rule' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.urlInvalid" class="form-text text-danger">
    {{ 'view_translations.incorrect_url_address' | translate }}
  </small>
  <small
    *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.pattern
    && !validators?.includes('password') && !validators?.includes('name')"
    class="form-text text-danger">
    {{ validators?.includes('password') ? ('password_validation_rule' | t ) : ('incorrect_data_format' | t )}}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.numberInvalid" class="form-text text-danger">
    {{ 'view_translations.only_numeric_value' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.minlength" class="form-text text-danger">
    {{ 'view_translations.too_short' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.maxlength" class="form-text text-danger">
    {{ 'view_translations.too_long' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.min" class="form-text text-danger">
    {{ 'view_translations.too_low' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.max" class="form-text text-danger">
    {{ 'view_translations.too_high' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.passwordsDoNotMatch" class="form-text text-danger">
    {{ 'view_translations.passwords_do_not_match' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.usernameAlreadyExists" class="form-text text-danger">
    {{ 'view_translations.username_already_exists' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.usernameReserved" class="form-text text-danger">
    {{ 'username_reserved' | t }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.invalidValue" class="form-text text-danger">
    {{ 'invalid_value' | t }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.emailAlreadyExists" class="form-text text-danger">
    {{ 'view_translations.email_already_exists' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.loginInvalid" class="form-text text-danger">
    {{ 'view_translations.username_validation_error' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.invalidZipCode" class="form-text text-danger">
    {{ 'view_translations.wrong_zip_pattern' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.invalidNip" class="form-text text-danger">
    {{ 'view_translations.wrong_nip_number' | translate }}
  </small>
  <small *ngIf="configForm.text.dirty && configForm.text.value?.length && configForm.text.errors?.invalidPhoneNumber" class="form-text text-danger">
    {{ 'view_translations.invalid_phone_number' | translate }}
  </small>
</div>
<div *ngIf="submitted && errorMsg" class="error-text" id="errorTextContainer2">
  <small class="form-text text-danger"> {{ errorMsg }} </small>
</div>
<!-- this is for handling error that comes from backend after submit -->
<div class="error-text" *ngIf="!isElementFocused && submitted && backendError">
  <small class="form-text text-danger"> {{ 'view_translations.incorrect_url_address' | translate }} </small>
</div>
